// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RTaNt","left":"styles_left__12X3I","desktopActions":"styles_desktopActions__2tyTo","title":"styles_title__2YXHF"};